import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import { UserPlus, ArrowRight } from "lucide-react";

export default function RegisterPage() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      login(data.token, data.user);
      toast.success("Conta criada com sucesso!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Falha no cadastro");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen text-white grain">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="glass rounded-3xl p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full bg-[#00F0FF]/10 border border-[#00F0FF]/40 flex items-center justify-center">
              <UserPlus className="w-5 h-5 text-[#00F0FF]" />
            </div>
            <div>
              <span className="text-xs uppercase tracking-[0.2em] text-white/40">
                Cadastro
              </span>
              <h1 className="font-display font-black text-2xl tracking-tight">
                Criar conta
              </h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Nome
              </label>
              <input
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="input-dark mt-2"
                placeholder="Seu nome"
                data-testid="register-name"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Email
              </label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="input-dark mt-2"
                placeholder="seu@email.com"
                data-testid="register-email"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Senha
              </label>
              <input
                type="password"
                required
                minLength={6}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="input-dark mt-2"
                placeholder="Mínimo 6 caracteres"
                data-testid="register-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-neon w-full mt-4"
              data-testid="register-submit"
            >
              {loading ? "Criando..." : "Criar conta"} <ArrowRight className="w-4 h-4" />
            </button>
          </form>

          <p className="mt-6 text-sm text-white/50 text-center">
            Já tem conta?{" "}
            <Link to="/login" className="text-[#FF007F] hover:underline" data-testid="link-login">
              Entrar
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
